const preview = (state = {}, action) => {
    switch (action.type) {
        case 'SET_PREVIEW_URL':
            return {
                ...state,
                url: action.payload
            };
        default:
            return state;
    }
};

export default preview;
